import React from 'react';
import { useUser } from '../../contexts/UserContext';
import SearchAccounts from './SearchAccounts';
import SearchCards from './SearchCards';

type SearchBarProps = {
  forDarkNavbar?: boolean;
};

const SearchBar = ({ forDarkNavbar }: SearchBarProps) => {
  const user = useUser();

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {user.hasPermission('phonecard_manage') ? (
        <SearchCards forDarkNavbar={forDarkNavbar} />
      ) : null}
      <SearchAccounts forDarkNavbar={forDarkNavbar} />
    </div>
  );
};

export default SearchBar;
